module.exports = __webpack_public_path__ + "static/img/wait-avatar.5a1bcec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wait-avatar.png
// module id = qJ+G
// module chunks = 1